import React from 'react';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import SubscriptionCallToActionComponent
  from '@fuww/library/src/SubscriptionCallToAction';
import messages from '../../lib/messages.mjs';
import LinkAndAnchor from '../LinkAndAnchor';
import { saveRouterState } from '../../lib/routerState';

const SubscriptionCallToAction = () => {
  const intl = useIntl();
  const router = useRouter();

  return (
    <SubscriptionCallToActionComponent
      callToActionMessage={intl.formatMessage(
        messages['subscriptionCallToAction.callToAction'])}
      saveMessage={intl.formatMessage(
        messages['subscriptionCallToAction.saveMessage'])}
      sellingPoints={[
        intl.formatMessage(
          messages['subscriptionCallToAction.exclusiveAccess'],
        ),
        intl.formatMessage(
          messages['subscriptionCallToAction.insiderForecasts'],
        ),
        intl.formatMessage(
          messages['subscriptionCallToAction.directInsights'],
        ),
      ]}
      youCanCancelMessage={intl.formatMessage(
        messages['subscriptionCallToAction.youCanCancel'],
      )}
      startReadingMessage={intl.formatMessage(
        messages['subscriptionCallToAction.startReading'],
      )}
      complimentaryAccessMessage={intl.formatMessage(
        messages['subscriptionCallToAction.complimentaryAccess'],
      )}
      subscriptionPriceMessage={intl.formatMessage(
        messages['subscriptionCallToAction.subscriptionPrice'],
      )}
      subscriptionBillingPeriodMessage={intl.formatMessage(
        messages['subscriptionCallToAction.subscriptionBillingPeriod'],
      )}
      LinkComponent={LinkAndAnchor}
      onClick={() => {
        saveRouterState(router);
      }}
    />
  );
};

export default SubscriptionCallToAction;
